import React, { useEffect, useState } from "react";
import "components/Layout/style.css";
import Grid from "@mui/material/Grid";
import TransectionImg from "assets/img/img6.svg";
import WelcomeLayout from "pages/Shared/WelcomeLayout";
import RadioButton from "components/Ui/RadioButton";
import { useFormik } from "formik";
import selectOption from "assets/mock/selectOption.json";
import { validation } from "helpers/Schema";
import { useStore } from "_Store";
import { getFilterStockByType } from "services/stock.service";
import { useContext } from "react";
import { Store } from "components/Ui";

const TransactionStep = (props) => {
  const { state } = useStore();
  const {
    state: {
      activeFarm,activeCampaign
    }
  } = useContext(Store);
  const [saveAndContinue, setSaveAndContinue] = useState(false);
  const [entriesOption, setEntriesOption] = useState([]);
  const [exitsOption, setExitsOption] = useState([]);
  const options = [
    {
      label: "Entrées",
      value: "ENTRIES",
    },
    {
      label: "Sorties",
      value: "EXITS",
    }
  ];



  useEffect(() => {
    const filterEntriesOption = selectOption.filter(
      (items) => items.inputs === "entries"
    );
    const filterExitsOption = selectOption.filter(
      (items) => items.inputs === "exits"
    );
    setEntriesOption(filterEntriesOption);
    setExitsOption(filterExitsOption);
  }, []);

  const formik = useFormik({
    initialValues: {
      type: state?.["tableDataResponse"]?.["type"] || "",
      // typeData: state?.["tableDataResponse"]?.["typeData"] || {},
    },
    validationSchema: validation,
    onSubmit: (vals) => {
      Object.keys(vals).forEach((key) => {
        if (vals[key] === null) {
          delete obj[key];
        }
      });
      props.onSubmit(vals, saveAndContinue);
    },
  });
  const { values } = formik

  function getStockSeedWithEntries(stocks) {
    const valeursRedondantes = [];

    for (let i = 0; i < stocks.length; i++) {
      const element = stocks[i];
      if (!valeursRedondantes.includes(element.seed)) {
        valeursRedondantes.push(element.seed);
      }
    }
    return valeursRedondantes;
  }
  useEffect(() => {
    if (values.type == 'EXITS') {
      getFilterStockByType({ farmId: activeFarm.id, filterType: 'ENTRIES' })
        .then(res => {
          const allEntrieStock = res.data.data;
          localStorage.setItem('maep_temp_entrie_seed', JSON.stringify(getStockSeedWithEntries(allEntrieStock)))
        })
        .catch(err => null)
    }
  }, [values.type])

  return (
    <div>
      <Grid className="stepFormfields">
        <WelcomeLayout
          title={"Type d'Opération"}
          containImg={TransectionImg}
          content={"Type d'Opération"}
          task={"Une opération de stockage est définie par deux types 'ENTREE' et 'SORTIE' qui représentent respectivement l'incrementation et la décrementation du stock d'une des cultures de votre campagne en cours."}
          handleSubmit={(save) => {
            formik.handleSubmit();
            setSaveAndContinue(save);
          }}
          buttonLabel={"Continuer"}
          backToStartBtn={{
            label: 'Précédent',
            onClick: () => {
              props.onBack();
            }
          }}
        >
          <div>
            <div className="questionPage">
              <div className="transection-option">
                <RadioButton
                  options={options}
                  value={formik.values?.["type"]}
                  handleChange={(e) => {
                    if (formik.values?.["type"]?.length) {
                      formik.setFieldValue("typeData", {});
                    }
                    formik.handleChange(e);
                  }}
                  formTitle={"Type d'Opération"}
                  name="type"
                  radioButtonClass={"optionforans"}
                  error={Boolean(formik.errors?.["type"])}
                />
                <Grid
                  className="cahiersheet-optionsheet"
                  style={{ padding: "0 20px" }}
                >
                </Grid>
              </div>
              {Boolean(formik.errors["type"]) && (
                <p className="errorText">{formik.errors["type"]}</p>
              )}
            </div>
          </div>
        </WelcomeLayout>
      </Grid>
    </div>
  );
};
export default TransactionStep;



